import { render, staticRenderFns } from "./CertificatesBuyModal.vue?vue&type=template&id=050dbe3d&scoped=true"
import script from "./CertificatesBuyModal.vue?vue&type=script&lang=js"
export * from "./CertificatesBuyModal.vue?vue&type=script&lang=js"
import style0 from "./CertificatesBuyModal.vue?vue&type=style&index=0&id=050dbe3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050dbe3d",
  null
  
)

export default component.exports